import { Observable } from 'rxjs';
import { BellNotification } from '@model/notification/bell-notification.model';

export abstract class BellNotificationGateway {
  abstract getUnread(): Observable<BellNotification[]>;
  abstract getUnreadCount(): Observable<number>;
  abstract markAsRead(id: string): Observable<void>;
  abstract markAllAsRead(): Observable<void>;
}
